import React from 'react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ChakraProvider } from '@chakra-ui/react';
import { routeTree } from './routeTree.gen';
import theme from './theme';
import { AppToastComponent } from '@/components';
import { authStore, initializeAuthStore } from '@/store';
import { queryClient } from '@/services'
import 'rsuite/dist/rsuite.min.css';
import './main.scss';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    auth: undefined!,
    queryClient: undefined!,
  },
});

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function InnerApp() {
  const auth = authStore.state;

  useEffect(() => {
    initializeAuthStore();
  }, []);
  return <RouterProvider router={router} context={{ auth, queryClient }} />;
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <InnerApp />
        <AppToastComponent />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ChakraProvider>
  );
}

// Render
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
